import { UserState } from '../../user/store/user.state';
import { userReducer } from '../../user/store/user.reducer';
import { ActionReducerMap } from '@ngrx/store';
import { CourseState } from '../../course/store/course.state';
import { courseReducer } from '../../course/store/course.reducer';
import { DigitalProductState } from '../../digitalProduct/store/digitalProduct.state';
import { digitalProductReducer } from '../../digitalProduct/store/digitalProduct.reducer';
import { SubscriptionState } from '../../subscription/store/subscription.state';
import { subscriptionReducer } from '../../subscription/store/subscription.reducer';

export interface AppState {
  user: UserState;
  course: CourseState;
  digitalProduct: DigitalProductState;
  subscription: SubscriptionState;
}

export const appInitialState:AppState = {
  user: {} as UserState,
  course: {} as CourseState,
  digitalProduct: {} as DigitalProductState,
  subscription: {} as SubscriptionState,
}

export const reducers: ActionReducerMap<AppState> = {
  user: userReducer,
  course: courseReducer,
  digitalProduct: digitalProductReducer,
  subscription: subscriptionReducer
};

export const CORE_FEATURE_NAME = 'core';
